module.exports = __webpack_public_path__ + "static/logo_small-180ba45b285f7b56875e389f5b2fb769.svg";